import { processingStateTypes } from "./constants";

type ProcessingState = (typeof processingStateTypes)[number];

export const getStateByID = (stateID: string): ProcessingState | undefined =>
  processingStateTypes.find((item) => item.id === stateID);
